import {useApplication} from "../../ApplicationProvider";
import {useNavigate, useParams} from "react-router-dom";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import Table from "../../components/table/Table";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import {observer} from "mobx-react";
import OrderLogFeature from "./OrderLogFeature";


function OrderLogScreen() {
    const {id} = useParams()
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new OrderLogFeature(application, navigator, id), navigator, [id]);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const ListOrderLogsContent = () => {
        return (
            <div>
                <LayoutContentToolbar title={`Historial de pedido ${id}`}/>
                <Table columns={feature.columns()} rows={feature.presentedOrderLogs()}/>
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => ListOrderLogsContent()}/>
    )
}

export default observer(OrderLogScreen)
